import React, { FunctionComponent, memo, useEffect, useState } from 'react';

import Svg from '../../../Svg/assets/scripts';
import close from '../../../../../../assets/images/icons/close.svg';
import flashError from '../../../../../../assets/images/icons/flash-error.svg';
import flashSuccess from '../../../../../../assets/images/icons/flash-success.svg';
import flashWarning from '../../../../../../assets/images/icons/flash-warning.svg';

import { FlashMessageProps, FlashMessageState } from './types';
import {
  FLASH_ERROR,
  FLASH_MOUNT,
  FLASH_SUCCESS,
  FLASH_TRANSITION,
  FLASH_TTL,
  FLASH_WARNING,
} from './constants';
import { flashMessageClassName } from './className';

const TYPE_TO_ICON = {
  [FLASH_ERROR]: flashError,
  [FLASH_SUCCESS]: flashSuccess,
  [FLASH_WARNING]: flashWarning,
};

const FlashMessage: FunctionComponent<FlashMessageProps> = props => {
  let timeout: NodeJS.Timeout;
  const [visible, setVisible] = useState<FlashMessageState>(false);
  const handleDelete = (): void => {
    clearTimeout(timeout);
    props.delete(props.id);
    if (typeof props.onDelete === 'function') props.onDelete();
  };
  const handleHide = (): void => {
    setVisible(false);
    setTimeout(handleDelete, FLASH_TRANSITION);
  };
  const handleShow = (): void => setVisible(true);
  useEffect(() => {
    setTimeout(handleShow, FLASH_MOUNT);
    if (props.dismissible === false) return;
    timeout = setTimeout(handleHide, FLASH_TTL);
    return () => clearTimeout(timeout);
  }, []);
  const className = flashMessageClassName({ props, state: { visible } });
  return (
    <div className={className.block()}>
      <div className={className.element('icon')}>
        <Svg symbol={TYPE_TO_ICON[props.type]} />
      </div>
      <div className={className.element('content')}>
        {props.title && (
          <strong
            className={className.element('title')}
            dangerouslySetInnerHTML={{ __html: props.title }}
          />
        )}
        {props.text && (
          <p
            className={className.element('text')}
            dangerouslySetInnerHTML={{ __html: props.text }}
          />
        )}
      </div>
      {props.dismissible && (
        <div
          className={className.element('close')}
          onClick={handleDelete}
          role="button"
          aria-label="Close"
        >
          <Svg symbol={close} />
        </div>
      )}
    </div>
  );
};

FlashMessage.defaultProps = { dismissible: true };

export default memo<FlashMessageProps>(FlashMessage);
